// extracted by mini-css-extract-plugin
export default {"root":"FiltersHeader_root__4tCiZ"};